/** Mirrors the response envelopes emitted by `backend/src/core/base`. */

export interface OneEnvelope<T> {
  data: T;
}

/**
 * Page metadata. Field naming (`page_size`, `total_pages`) matches the
 * backend's wire format — don't camelCase here or reads break.
 */
export interface PageMeta {
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
}

export interface ManyEnvelope<T> {
  data: T[];
  page: PageMeta;
}

export interface ListQuery {
  page?: number;
  pageSize?: number;
  sort?: string;
  /** Each value can be a primitive or an array (for `multi: true` filters). */
  filter?: Record<string, string | number | Array<string | number> | undefined>;
  include?: string[];
}

/** Builds an axios `params` object from a typed ListQuery. */
export function listQueryToParams(q: ListQuery | undefined): Record<string, unknown> {
  if (!q) return {};
  const params: Record<string, unknown> = {};
  if (q.page !== undefined) params.page = q.page;
  if (q.pageSize !== undefined) params.page_size = q.pageSize;
  if (q.sort) params.sort = q.sort;
  if (q.include?.length) params.include = q.include.join(',');
  if (q.filter) {
    for (const [key, value] of Object.entries(q.filter)) {
      if (value === undefined || value === null) continue;
      // Multi filters are joined as comma-separated strings — the backend
      // parser rejects array params with "must be a string value".
      params[`filter[${key}]`] = Array.isArray(value) ? value.join(',') : value;
    }
  }
  return params;
}
